module.exports = __webpack_public_path__ + "img/sld_scb_19_t1_b1_green.c1e66a5c.svg";